import Modal from '../../../../components/Modal/Modal';
import { useTheme } from 'styled-components';
import Loading from '../../../../components/Loading';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import Information from './Information';
import { ConvertObjectToArrayCreditDetails } from './ConvertObjectsToArray';
import { Button } from '../../../../components/Button/Button.styles';
import { CheckCircle } from '../../../../assets/icon';
import ModalPixRefundRequest from './ModalPixRefundRequest';
import PropTypes from 'prop-types';

const ModalPixRefund = ({ open, close }) => {
  const theme = useTheme();
  const [isModalCloseDevoluctionOpen, setIsModalCloseDevoluctionOpen] = useState(false);

  const { detailsPixRefund, loadingDetailsPixRefund } = useSelector((state) => state.pixRefund);

  const showButton = detailsPixRefund?.status != 'FECHADO';

  const detailsArray = ConvertObjectToArrayCreditDetails(detailsPixRefund);

  const submitCloseDevoluction = (action) => {
    setIsModalCloseDevoluctionOpen(true);
  };

  return (
    <Modal open={open} close={close} title="Devolucao" width={'39.889vw'}>
      {loadingDetailsPixRefund ? (
        <Loading />
      ) : (
        <div role="modal-dados-cliente">
          <Information title="Detalhes da devolucao" data={detailsArray} />
          {showButton && (
            <Button
              backgroundcolor={theme.colors.buttonApproved}
              width="35.111vw"
              height="3.125vw"
              hoverbgcolor={theme.colors.buttonApprovedHover}
              hovercolor={theme.colors.buttonApprovedHoverText}
              onClick={() => submitCloseDevoluction()}
              mycolor={theme.colors.buttonApprovedText}
              type="submit"
              margin={'2.083vw 0 0 0'}
            >
              <CheckCircle />
              <span>Acoes</span>
            </Button>
          )}
        </div>
      )}
      {
        <ModalPixRefundRequest
          data={{
            idRefund: detailsPixRefund?.id,
            idTypeRefund: detailsPixRefund.refundreasonId,
            isClaimant: detailsPixRefund?.isClaimant,
          }}
          open={isModalCloseDevoluctionOpen}
          close={() => setIsModalCloseDevoluctionOpen(false)}
        />
      }
    </Modal>
  );
};

ModalPixRefund.propTypes = {
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};
export default ModalPixRefund;
